export default {
  footer: {
    description: "Empoderando emprendedores latinos a escalar sus negocios con marketing digital, IA y sistemas automatizados.",
    navTitle: "Navegación",
    servicesTitle: "Servicios",
    newsletterTitle: "Newsletter",
    newsletterDesc: "Recibe tips de marketing digital, IA y negocios directamente en tu correo.",
    subscribe: "Suscribirme",
    subscribing: "Enviando...",
    subscribeSuccess: "¡Gracias por suscribirte!",
    rights: "© 2024 Smart Business Digital Solutions LLC. Todos los derechos reservados.",
    privacy: "Privacidad",
    terms: "Términos",
    links: {
      home: "Inicio",
      about: "Nosotros",
      services: "Servicios",
      consulting: "Consultoría Empresarial",
      products: "Productos",
      contact: "Contacto",
      academy: "Academia"
    }
  },
  floating: {
    academy: "Unirse a la Academia",
    consultation: "Reservar Consulta"
  },
  notfound: {
    title: "Esta página no ha sido generada",
    subtitle: "Dime más sobre esta página para que pueda generarla"
  }
};
